import { TokenKeys } from './Framework';

export const blankToken: TokenKeys = {
    keyStore: '',
    keyBranch: '',
    keyProfile: '',
    keyPreviewFlag: '',
    keyNameId: '',
    keyVin: '',
    keyAppt: '',
    keyRo: '',
    keyOpCode: '',
    keyExpireDays: '',
    keyResetPassFlag: '',
    keyServiceDocsFlag: '',
    keyTlmId: '',
    keyDocType: '',
    keyRcardAvailFlag: '',
    keyStationNum: '',
    keyTaskId: '',
};